module.exports = "/_next/static/images/shield-ea699c3c315217a32bcc90bdf0970f63.svg";